//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    props: [],
    fetchOnServer: false,
    async fetch() {
        const locale = 'fi';
        const tags = await this.$contentful.getTags();
        this.tags = tags.items;
        if (this.$route.query.pageSize) {
            this.pageSize = this.$route.query.pageSize;
        }
        if (this.$route.query.currentPage) {
            this.currentPage = parseInt(this.$route.query.currentPage);
        } else {
            this.currentPage = 1;
        }
        const skip = this.pageSize * (this.currentPage - 1);
        const searchParams = {
            content_type: 'blogPage',
            locale,
            include: 4,
            limit: this.pageSize,
            skip,
            order: '-sys.createdAt',
        };
        if (this.filter.length) {
            searchParams['metadata.tags.sys.id[in]'] = this.filter.toString();
        }
        const pages = await this.$contentful.getEntries(searchParams);
        this.total = Math.ceil(pages.total / this.pageSize);
        this.pages = pages.items;
    },
    data() {
        return {
            pages: [],
            tags: [],
            filter: [],
            pageSize: 30,
            total: 0,
            currentPage: 1,
        };
    },
    watch: {
        '$route.query'() {
            this.$fetch();
        },
    },
    methods: {
        clearFilters() {
            this.filter = [];
            this.$fetch();
        },
        addToFilters(filterId) {
            if (this.filter.includes(filterId)) {
                this.filter.splice(this.filter.indexOf(filterId), 1);
            } else {
                this.filter.push(filterId);
            }
            this.$fetch();
        },
        onPaginationUpdate(index) {
            const { query } = this.$route;
            delete query.currentPage;
            this.$scrollTo('#blog-list');
            this.$router.push({ path: this.$route.path, query: { currentPage: index, ...query } });
        },
    },
};
